import { observer } from "mobx-react";
import React, { Component } from "react";
import { InjectedIntl, injectIntl, IntlProvider } from "react-intl";
import { MainStore } from "../../../stores/MainStore";
import Box from "../../Box";
import Label from "../../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  intl: IntlProvider & InjectedIntl;
}

interface IState { }

@observer
class BocconiAndCountry extends Component<IProps, IState> {
  getFormattedMessage(id: string) {
    const { intl } = this.props;
    return intl.formatMessage({ id });
  }

  getNumberOfBoxesClassName(numberOfBoxes: Number) {
    switch (numberOfBoxes) {
      case 5:
        return classes.numberOfBoxes5;
      case 6:
        return classes.numberOfBoxes6;
      default:
        return null;
    }
  }

  render() {
    const { store } = this.props;
    const { selectedState } = store;

    if (!selectedState) return null;

    return selectedState.hideBocconiAndCountry === true ? null : (
      <div className={classes.BocconiAndCountry}>
        <div className={classes.InlineTitle}>
          <Label
            big
            bold
            text={`${this.getFormattedMessage(
              "details.bocconiand"
            )} ${this.getFormattedMessage(`${selectedState.id}-label`)}`}
          />
        </div>
        <div className={classes.BoxContainer}>
          {selectedState.partnerUniversities && (
            <Box className={classes.InfoBox} vertical>
              <Label extraBig bold text={selectedState.partnerUniversities} />
              {selectedState.partnerUniversitiesAdditionalInfos === true ? (
                <Label
                  extraSmall
                  normal
                  id={`details.partner-universities-${selectedState.id}`}
                />
              ) : (
                  <Label extraSmall normal id={"details.partner-universities"} />
                )}
            </Box>
          )}
          {selectedState.studentsExchanged && (
            <Box vertical>
              <Label extraBig bold text={selectedState.studentsExchanged} />
              <Label extraSmall normal id={"details.students-exchanged"} />
            </Box>
          )}
          {selectedState.internshipPlacement && (
            <Box vertical>
              <Label extraBig bold text={selectedState.internshipPlacement} />
              <Label extraSmall normal id={"details.internship-placement"} />
            </Box>
          )}
          {selectedState.bocconiAlumni && (
            <Box vertical>
              <Label extraBig bold text={selectedState.bocconiAlumni} />
              <Label extraSmall normal id={"details.bocconi-alumni"} />
            </Box>
          )}
          {selectedState.bocconiJobsAbroad && (
            <Box vertical>
              <Label extraBig bold text={selectedState.bocconiJobsAbroad} />

              <Label
                extraSmall
                normal
                id={`details.bocconi-jobs-${selectedState.id}`}
              />
            </Box>
          )}
          {selectedState.inCompanyTraining && (
            <Box vertical>
              <Label extraBig bold text={selectedState.inCompanyTraining} />

              <Label
                extraSmall
                normal
                id={`details.bocconi-in-company-training-${selectedState.id}`}
              />
            </Box>
          )}
        </div>
      </div>
    );
  }
}
export default injectIntl(BocconiAndCountry);
